import { Injectable } from "@angular/core";
import { BehaviorSubject, first, Observable, ReplaySubject } from "rxjs";
import { ConfigService } from "./config/config.service";
import { Orientation } from "../models/enums/orientation.enum";
import { HttpClient, HttpHeaders, HttpParams } from "@angular/common/http";
import { PlatformService } from "./platform/platform.service";
import { GlobalConstants } from "../global-constants";
import { NoticiaReels } from "../models/interfaces/noticia.interface";
@Injectable({
  providedIn: "root",
})
export class ReelsService {
  private readonly API_URL: any;
  private readonly API_SHARED_URL: any;
  private readonly constantesGlobales: any;

  private storageKey = "currentOrientation";
  private defaultOrientation = Orientation.Clasico;
  private _isReelsSubject: ReplaySubject<boolean> = new ReplaySubject(1);
  private orientationSubject = new BehaviorSubject<Orientation>(this.getSavedOrientation());
  public orientation$: Observable<Orientation> = this.orientationSubject.asObservable();
  private hideOrientation = new BehaviorSubject<boolean>(false);
  public hideOrientation$: Observable<boolean> = this.hideOrientation.asObservable();
  private isMobileDevice = new BehaviorSubject<boolean | null>(null);
  public isMobileDevice$: Observable<boolean> = this.isMobileDevice.asObservable();
  constructor(
    private configService: ConfigService,
    private readonly httpClient: HttpClient,
    private readonly platformService: PlatformService,
  ) {
    const host = this.platformService.getLocationHostname();
    this.constantesGlobales = new GlobalConstants(host);
    this.API_URL = this.constantesGlobales.urlApi;
    this.API_SHARED_URL = this.constantesGlobales.urlSharedApi;

    const configPrensa = configService.getConfigPrensa();
    if (configPrensa) {
      configPrensa.pipe(first()).subscribe((config) => {
        if (config && config.general["app-home"].portada_reels_movil === "true") {
          this.setIsReels(true);
        }
      });
    }
  }

  public getIsReels(): Observable<boolean> {
    return this._isReelsSubject.asObservable();
  }
  public setIsReels(value: boolean) {
    return this._isReelsSubject.next(value);
  }

  public sethideOrientation(s) {
    this.hideOrientation.next(s);
  }
  public setIsMobile(s) {
    this.isMobileDevice.next(s);
  }
  // Verifica si estamos en el navegador (no en SSR) antes de acceder a localStorage
  private isBrowser(): boolean {
    return typeof window !== "undefined" && typeof window.localStorage !== "undefined";
  }

  // Recupera el valor guardado en localStorage, si no existe, retorna el valor predeterminado.
  private getSavedOrientation(): Orientation {
    if (this.isBrowser()) {
      const savedOrientation = localStorage.getItem(this.storageKey); // Recuperamos como string desde localStorage
      // Si savedMode es un valor válido del enum, lo retornamos, si no, usamos el valor por defecto
      if (Object.values(Orientation).includes(savedOrientation as Orientation)) {
        return savedOrientation as Orientation; // Convertimos el string a un valor del enum
      }
    }
    return this.defaultOrientation; // Si no hay valor o es inválido, usamos el predeterminado
  }

  setOrientation(orientation: Orientation): void {
    if (this.isBrowser()) {
      localStorage.setItem(this.storageKey, orientation);
    }
    this.orientationSubject.next(orientation);
  }

  /**
   * Obtiene las noticias de los reels aportando el id del ámbito, el id de la noticia de partida y la página.
   * @param idAmbito - Id del ámbito.
   * @param idNoticia - Id de la noticia a partir de la cual se obtienen las noticias.
   * @param page - Número de página.
   * @returns {Observable<any>} - Observable con la respuesta de la petición.
   */
  public getNoticiasReels(idAmbito: number, idNoticia: number = null, page: number): Observable<NoticiaReels[]> {
    const headers = new HttpHeaders({
      "Content-Type": "application/x-www-form-urlencoded",
      Accept: "application/json, text/javascript, */*; q=0.01",
    });
    let body = new HttpParams().set("id_ambito", String(idAmbito)).set("page", String(page));
    if (idNoticia) {
      body = body.set("id_noticia", String(idNoticia));
    }
    return this.httpClient.get<NoticiaReels[]>(this.API_URL + "/noticiasReels", { headers: headers, params: body });
  }
}
